import { DatePipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { CacheAgeColor, CACHE_AGE_COLORS, DEFAULT_AGE_OLD_MINUTES, DEFAULT_AGE_TOO_OLD_MINUTES, getCacheAgeColor } from '../../constants';

@Component({
    standalone: true,
    imports: [NgIf, NgClass, DatePipe, FontAwesomeModule, TranslateModule],
    selector: 'qwyk-cache-indicator',
    templateUrl: './cache-indicator.component.html',
    styles: [
        `
            .cache-indicator-container {
                font-weight: normal;
                min-height: 35px;
            }
            .cache-refreshed {
                animation: cache-flash 0.5s ease-in-out;
            }
            @keyframes cache-flash {
                0% {
                    opacity: 0;
                    transform: translateY(-4px);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
        `,
    ],
})
export class CacheIndicatorComponent implements OnChanges, OnDestroy {
    @Input() cachedAt: string | null = null;

    @Input() name = 'Data';

    @Input() ageOld: number = DEFAULT_AGE_OLD_MINUTES;

    @Input() ageTooOld: number = DEFAULT_AGE_TOO_OLD_MINUTES;

    @Input() loading = false;

    @Output() refreshRequested = new EventEmitter<void>();

    public justRefreshed = false;
    private refreshPending = false;
    private refreshTimer: ReturnType<typeof setTimeout> | null = null;
    protected readonly CACHE_AGE_COLORS = CACHE_AGE_COLORS;

    public get ageColor(): CacheAgeColor {
        return getCacheAgeColor(this.cachedAt, this.ageOld, this.ageTooOld);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['cachedAt'] && this.refreshPending) {
            this.refreshPending = false;
            this.showRefreshedMessage();
        }
    }

    ngOnDestroy(): void {
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer);
        }
    }

    public onRefresh(): void {
        this.refreshPending = true;
        this.refreshRequested.emit();
    }

    private showRefreshedMessage(): void {
        this.justRefreshed = true;
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer);
        }
        this.refreshTimer = setTimeout(() => {
            this.justRefreshed = false;
            this.refreshTimer = null;
        }, 3000);
    }
}
